import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContractService } from '../../../../../../shared/store/contract/contract.service';
import { Observable } from 'rxjs';
import {
  ContractModel,
  ContractStatusHistoryModel,
} from 'src/app/shared/store/contract/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SubHeaderService } from '../../../../../../shared/store/subheader/subheader.service';
import { DocumentModel } from '../../../../../../shared/store/document/types';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';
import { take } from 'rxjs/operators';
import { ModalContentComponent } from '../../../../../../shared/components/modal-content/modal-content.component';
import { ActionButton } from '../../../../../../shared/components/modal-content/action-button';
import { toFirstLetterLower } from '../../../../../../shared/helper/stringhelper';
import { SourceEnum } from '../../../../../../shared/store/typeahead/types';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../../../shared/service/modal.service';
import { ModalComponentKey } from 'src/app/shared/service/modal-component';

@UntilDestroy()
@Component({
  selector: 'app-contract-details-status-histories',
  templateUrl: './contract-details-status-histories.component.html',
  styleUrl: './contract-details-status-histories.component.scss',
  standalone: false,
})
export class ContractDetailsStatusHistoriesComponent
  implements OnInit, OnDestroy
{
  contractDetail$: Observable<ContractModel>;
  rowData: ContractStatusHistoryModel;

  constructor(
    private readonly contractService: ContractService,
    private readonly subHeaderService: SubHeaderService,
    private readonly route: ActivatedRoute,
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
  ) {
    this.contractDetail$ = this.contractService.getByUniqueId.value$;
  }

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'contractStatusHistoryDelete') {
          this.onDelete();
        }
        if (x == 'contractStatusHistoryEdit') {
          this.onOpenModalEdit();
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  onGetRowData() {
    //copy the data
    const result = this.rowData;

    //when we get the data, reset the data
    this.onSetRowData(undefined);

    //return the copy of the data
    return result;
  }

  onSetRowData(rowData: any) {
    this.rowData = rowData;
  }

  private onDelete() {
    const contractStatusHistory: ContractStatusHistoryModel =
      this.onGetRowData();

    let result$ = this.contractService.deleteContractStatusHistory.call({
      contractId: contractStatusHistory.contractId,
      contractStatusHistoryId: contractStatusHistory.id,
    });

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.contractService.deleteContractStatusHistory.reset();
    });
  }

  private onOpenModalEdit() {
    const contractStatusHistory: ContractStatusHistoryModel =
      this.onGetRowData();

    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.ContractStatusHistoryEdit,
      );
    modalRef.componentInstance.title = 'CONTRACT_STATUS_HISTORY_LBL_TITLE';
    modalRef.componentInstance.cancelButton = true;
    modalRef.componentInstance.buttons = [
      <ActionButton>{
        actionName: toFirstLetterLower('contractStatusHistory') + 'Update',
      },
    ];
    modalRef.componentInstance.inputParams = {
      source: SourceEnum.Modal,
      contractId: contractStatusHistory.contractId,
      contractStatusHistoryId: contractStatusHistory.id,
    };

    modalRef.result
      .then((id) => {
        if (id >= 0) {
          modalRef.close();
        }
      })
      .finally(() => {
        //avoid error on cancel
      });
  }

  ngOnDestroy(): void {
    this.contractService.deleteContractStatusHistory.reset();
  }
}
